import { render, staticRenderFns } from "./3gwan.vue?vue&type=template&id=79e0e4a1&scoped=true&"
import script from "./3gwan.vue?vue&type=script&lang=js&"
export * from "./3gwan.vue?vue&type=script&lang=js&"
import style0 from "./particulars.css?vue&type=style&index=0&id=79e0e4a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e0e4a1",
  null
  
)

export default component.exports